 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		104: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"vendors~pages-admin-teams~pages-class-details-logged-in~pages-class-details-logged-out~pages-classes~7547aa81","1":"dllVendors","2":"vendors~pages-adminMarketingBanner~pages-class-details-logged-in~pages-class-details-logged-out~page~19f89f02","3":"vendors~pages-adminMarketingBanner~pages-class-details-logged-in~pages-class-details-logged-out~page~e68b6694","4":"vendors~pages-adminMarketingBanner~pages-class-details-logged-out~pages-classes~pages-classes-class-~7a68ff1c","5":"tinymce","6":"d3","7":"vendors~pages-adminMarketingBanner~pages-classes-class-collections~pages-search~pages-site","8":"pages-embed-video~pages-site-join~pages-tutorials-show","9":"pages-groups~pages-userProfile-discussionShow","10":"pages-embed-video~pages-site-join","11":"pages-site-settings-payment~pages-teams-checkout","12":"vendors~pages-customLists-lists~pages-workshops-show","13":"pages-adminMarketingBanner","14":"pages-amas","15":"pages-class-details-logged-in","16":"pages-class-details-logged-out","17":"pages-classes","18":"pages-customLists","19":"pages-error","20":"pages-groups","21":"pages-home","22":"pages-marketingPages","23":"pages-membership","24":"pages-notifications","25":"pages-projects","26":"pages-redeem","27":"pages-search","28":"pages-site","29":"pages-teach","30":"pages-teacherStats","31":"pages-teaching","32":"pages-teams","33":"pages-tutorials","34":"pages-userProfile","35":"pages-visa","36":"pages-workshops","37":"pages-yourClasses","38":"vendors~pages-visa","39":"pages-admin-adjust-team-seats","40":"pages-admin-batch-delete-users","41":"pages-admin-coupons","42":"pages-admin-group-requests-show","43":"pages-admin-monthly-revenue","44":"pages-admin-teacher-payout","45":"pages-admin-teams","46":"pages-admin-trust-and-safety","47":"pages-admin-users-show","48":"pages-adminMarketingBanner-edit","49":"pages-amas-form","50":"pages-checkout-item","51":"pages-class-details-logged-in-class-admin","52":"pages-classes-class-collections","53":"pages-classes-create","54":"pages-classes-video-lessons-table","55":"pages-customLists-form","56":"pages-customLists-lists","57":"pages-customLists-show","58":"pages-embed-project","59":"pages-embed-video","60":"pages-giftCards-form","61":"pages-launch-common","62":"pages-membership-cancel","63":"pages-membership-cancel-step-two","64":"pages-membership-paypal-cancel","65":"pages-membership-paypal-success","66":"pages-membership-perks","67":"pages-membership-react-checkout","68":"pages-membership-rejoin","69":"pages-membership-welcome","70":"pages-projects-edit","71":"pages-reviews-create","72":"pages-site-gallery","73":"pages-site-join","74":"pages-site-login","75":"pages-site-premium-landing","76":"pages-site-scholarships","77":"pages-site-settings-account","78":"pages-site-settings-notifications","79":"pages-site-settings-payment","80":"pages-site-settings-react-account","81":"pages-site-settings-referrals","82":"pages-site-settings-teacher-referrals","83":"pages-site-settings-team-administration","84":"pages-site-signup","85":"pages-teach-form","86":"pages-teach-handbook","87":"pages-teams-activate","88":"pages-teams-checkout","89":"pages-teams-contact","90":"pages-teams-new","91":"pages-teams-signup","92":"pages-tutorials-form","93":"pages-tutorials-show","94":"pages-userProfile-discussionShow","95":"pages-userProfile-discussions","96":"pages-visa-check","97":"pages-workshops-form","98":"pages-workshops-my-workshops","99":"pages-workshops-show","100":"pages-workshops-test-index","101":"vendors~pages-membership-react-checkout","102":"vendors~pages-projects-edit","103":"vendors~pages-site-gallery"}[chunkId]||chunkId) + ".build." + {"0":"873d471e70f89b7be25e","1":"50411ef6891ce41eb95e","2":"921ebf23a9922f506a5d","3":"924d1957321b75d47dd4","4":"9c320d7d40302133a992","5":"384f38d29280888f400e","6":"5475ea87d829906e260c","7":"7c4803022864ebb1048a","8":"a253b6ea3c7c95e53d9a","9":"80d70600d6fa3cf73a31","10":"33c523acfda67abbea3f","11":"5b6804bdf39ed4209f5f","12":"76586d76b562603d8848","13":"650883f6456fd0e920de","14":"21d037269a5da8d3baa7","15":"85e375d329a31eedbe7c","16":"1d4d75268c04b8923273","17":"8036bd3ac2e62ea83629","18":"abafe125d8702c870dcf","19":"560f8ae6020095e0b6c1","20":"fc1cc3a6bdfb623a1afb","21":"9b057df29f286fe5c57c","22":"3f9c0ded6b4a562a7fb8","23":"620b75332ee453ab2f28","24":"64a7a321b6bcd0d21ef1","25":"5532d289c9fecace2be5","26":"b67d8b7a2e74e86fd721","27":"5d82de4a8ca4d3fecfcb","28":"98c393f59f460049dfa9","29":"a4978ba981904a75968b","30":"5b360fd65787253ceb63","31":"22f6ad24d57a920a39bf","32":"79571ac0aee1468a5c52","33":"080559292f165285af2b","34":"b0013887447568e73b72","35":"76580b39237a95fceee1","36":"d4758ba3b745454f823c","37":"0d6c7f9a7ff12dceed7f","38":"f87280f92007b303fcc5","39":"73742daa4ef1618565e0","40":"49b016524fe1bae80176","41":"b1ace8b92089baa92d89","42":"485d328cc4e291ace7e4","43":"c95fcc7b7972efebc34c","44":"83fe081615bd89d76896","45":"ae86bca0c8e086086685","46":"cac1f3882173d8ad48b2","47":"d6ad2fd8316b1a3fcf7a","48":"661751a5c9e961e73123","49":"78e16aadccda9044d010","50":"378335a68bec2414e168","51":"cf83b08a2f72b9c515be","52":"c5b8565d986d7e798d0b","53":"f6168992cb27ae80c985","54":"11f8a05760ba7a97896b","55":"e6764b5d1e7db9f5a696","56":"b0ca46dd43d6d5070879","57":"b4668e3b42475d7562f4","58":"fdff4c975aae429f284c","59":"858ffd426cd542878f29","60":"2e6e9f2d3c62d0c252d3","61":"ca46e2f10c16b5a6972b","62":"fd34935fe6fbf3a2af3b","63":"af3c38bdea60cb68970f","64":"d843c08c85638e6a5d63","65":"2fda63dbf2ea2095b7d5","66":"b838375a1aa2d4d18c04","67":"eef9cf6f0449f7e7905e","68":"591d2299a35b58b2ae9f","69":"8c7fa49072737b3fc62f","70":"2e80ddcbd70d72c00d7c","71":"9c4a9b6c557629032244","72":"d623ac8a903eac3be310","73":"92258f7e722d3cf5c240","74":"2a3c095141043e4122c2","75":"260ed648867ad6f6f544","76":"74dff0c3d77a0895c2d7","77":"a89742164b51f80e167c","78":"739ea75232d1e5814d64","79":"da1c2d3652fa369d2894","80":"1ea668f185fc5c21275b","81":"217e7efc1cc458eb23ad","82":"633d572d72fef0f39d18","83":"49a628de8d70e63c5a19","84":"587404d3fcd66d326921","85":"4199995e99a76cff2509","86":"92e67c9f6f63045bf515","87":"52374879557b135498f3","88":"01d93659f9ca56c8f543","89":"00f42fa0d3facc979575","90":"766ce0cdd786cad353c9","91":"6697f4870e6f2ba29fda","92":"a18f1c337299da26ff8c","93":"6f73afb007b0e0f6409a","94":"ab20c825950004ed29e8","95":"6907ba6b4dfc27fc1335","96":"f4b89a5ee7eff9527394","97":"a0596869a93f28353460","98":"aeab5d8a821e20589b10","99":"b27acb4d2916540c9aa7","100":"691b790c09f383880921","101":"76ae1a25bc049d00b7d1","102":"094f64ede03d3c31d208","103":"a5054a47b69eb123646d","105":"a54a5aaf7f894522924e","106":"5c563479babc643f1265"}[chunkId] + ".min.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://static.skillshare.com/build/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 700);
